export default __webpack_public_path__ + "static/xacobeo-2027-62183a3d50148ec8589d360a2d3c8d8a.svg";